import Color from "color";

export const getBlendedColor = (colorCodes: (string | undefined)[], ratio: number = 0.5) =>
  colorCodes
    .filter((color) => !!color)
    .map((color) => Color(color))
    .reduce((mergedColor, colorCode) => mergedColor.mix(colorCode, ratio));

export const getBlendedColorOnWhite = (colorCodes: (string | undefined)[], ratio: number = 0.5) =>
  getBlendedColor(["white", ...colorCodes], ratio);

/**
 * @param backgroundColor
 * @param contrast 0.0 - 1.0
 */
export const getContrastingTextColor = (backgroundColor: string, contrast = 0.7) => {
  const background = Color(backgroundColor);
  return background.isLight()
    ? background.mix(Color("black"), contrast)
    : background.mix(Color("white"), contrast);
};

// Calculates a dynamic text color using an non-linear "easing curve".
// The lightness offset stays very close to +/-60 for most colors, reserving the
// maximum +/-100 offset for extreme blacks and whites to ensure high contrast
export const getAdaptiveTextColor = (backgroundColor: string) => {
  const CURVE_INTENSITY = 30;
  const LIGHTNESS_RANGE = { MIN: 60, MAX: 100 };
  const DYNAMIC_RANGE = LIGHTNESS_RANGE.MAX - LIGHTNESS_RANGE.MIN;

  const originalColor = Color(backgroundColor);
  const lightness = originalColor.lightness();
  let offset: number;

  if (originalColor.isDark()) {
    // Normalize the lightness to a 0-1 scale
    const normalized = lightness / 50;
    const eased = Math.pow(normalized, 1 / CURVE_INTENSITY);
    offset = LIGHTNESS_RANGE.MAX - eased * DYNAMIC_RANGE;
  } else {
    // Normalize the lightness to a 0-1 scale
    const normalized = (lightness - 50) / 50;
    const eased = Math.pow(normalized, CURVE_INTENSITY);
    offset = -LIGHTNESS_RANGE.MIN - eased * DYNAMIC_RANGE;
  }

  return originalColor.lightness(lightness + offset).hex();
};
